<template>
    <a-modal :bodyStyle="{ maxHeight: '80vh', overflow: 'auto' }" :centered="true" :title="state.modalTitle"
        :width="1200" :open="open" :confirmLoading="state.confirmLoading" :maskClosable="state.maskClosable"
        @ok="onFormSubmit" @cancel="cancelClick">
        <template #footer>
            <a-button key="取消" @click="cancelClick">取消</a-button>
            <a-button key="确定提交" type="primary" :loading="state.loading" @click="onFormSubmit">确定提交</a-button>
        </template>
        <a-spin :spinning="state.loading">
            <a-form ref="formRef" :model="formState" :rules="rules" v-bind="formLayout">
                <!-- 基础信息 -->
                <a-form-item name="mailing_kdgs" label="快递公司" required>
                    <a-radio-group v-model:value="formState.mailing_kdgs" button-style="solid">
                        <a-radio-button :value="1"><img :src="formState.mailing_kdgs == 2 ? jdIconBlack : jdIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 京东快递 </a-radio-button>
                        <a-radio-button :value="2"><img :src="formState.mailing_kdgs == 1 ? sfIconBlack : sfIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 顺丰快递 </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="付款方式" name="pay_type">
                    <a-radio-group v-model:value="formState.pay_type" button-style="solid" required>
                        <a-radio-button :value="1">寄付（<span v-if="formState.mailing_kdgs == 1">自动扣余额</span><span
                                v-if="formState.mailing_kdgs == 2">顺丰速运小程序->查快递->待支付付款</span>）
                        </a-radio-button>
                        <a-radio-button :value="2">到付 </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="物品名称" required> <a-input style="width: 400px" v-model:value="formState.goodsname"
                        type="textarea"></a-input> </a-form-item>
                <a-form-item label="备注（选填）"> <a-input style="width: 400px" v-model:value="formState.remark"
                        type="textarea"></a-input> </a-form-item>
                <a-form-item label="邮寄时间" name="is_timing">
                    <a-radio-group v-model:value="formState.is_timing">
                        <a-radio :value="1"> 立马邮寄 </a-radio>
                        <a-radio :value="2"> 定时邮寄 </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="上门取货时间" v-if="formState.is_timing == 2" required>
                    <a-date-picker v-model:value="formState.timing_time" :format="format" show-time />
                </a-form-item>

                <div class="d-flex">
                    <div class="flex-1">
                        <a-form-item label="寄件人姓名" name="send_consignee_name" required>
                            <a-input placeholder="请输入寄件人姓名" v-model:value="formState.send_consignee_name"></a-input>
                        </a-form-item>
                        <a-form-item label="寄件人电话" name="send_tel" required>
                            <a-row>
                                <a-col :span="16">
                                    <a-input placeholder="请输入寄件人电话" v-model:value="formState.send_tel" @change="
                                        (v) => {
                                            phoneChange(v, 'send_tel')
                                        }
                                    "></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="state.sendLoading" type="primary" @click="getMailling(1)"
                                        style="margin-left: 12px" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="寄件人省市区" name="send_paua">
                            <AddressCascader width="100%" v-model:value="formState.send_paua"
                                @change="senderPauaChange">
                            </AddressCascader>
                        </a-form-item>
                        <a-form-item label="寄件人详细地址" name="send_address" required>
                            <a-textarea placeholder="请选择寄件人详细地址" v-model:value="formState.send_address"
                                @blur="senderAddressChange" />
                            <a-button type="primary" @click="parseReceiveAddress"
                                :loading="state.parseReceiveAddressLoading" style="margin-top: 5px;"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                    <div class="flex-1">
                        <a-form-item label="收件人姓名" name="receive_consignee_name" required>
                            <a-input v-model:value="formState.receive_consignee_name" placeholder="请输入收件人姓名"></a-input>
                        </a-form-item>
                        <a-form-item label="收件人电话" name="receive_tel" required>
                            <a-row>
                                <a-col :span="16">
                                    <a-input v-model:value="formState.receive_tel" @change="
                                        (v) => {
                                            phoneChange(v, 'receive_tel')
                                        }
                                    " placeholder="请输入收件人电话"></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="state.receiveLoading" type="primary" @click="getMailling(2)"
                                        style="margin-left: 12px" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="收件人省市区" name="receive_paua">
                            <AddressCascader width="100%" v-model:value="formState.receive_paua"
                                @change="recipientChange">
                            </AddressCascader>
                        </a-form-item>
                        <a-form-item label="收件人详细地址" name="receive_address" required>
                            <a-textarea placeholder="请选择收件人详细地址" v-model:value="formState.receive_address"
                                @blur="receiveAddressChange" />
                            <a-button type="primary" @click="parseReceiveAddress2"
                                :loading="state.parseReceiveAddressLoading2" style="margin-top: 5px;"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </a-spin>
        <!-- 公司添加人员 -->
    </a-modal>
</template>

<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import UploadTmp from '@/components/base/UploadTmp.vue'
import { reactive, onMounted, nextTick, h, ref, onBeforeUnmount, watch, computed } from 'vue'
import { message, Modal } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import dayjs from 'dayjs'
import AddressCascader from '@/components/base/AddressCascader.vue'
import { mobileRequiredValidator, mobileValidator } from '@/utils/util'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import jdIconBlack from '@/assets/icons/jd-icon-black.png'
import jdIconWhite from '@/assets/icons/jd-icon-white.png'
import { ScanOutlined, CloudDownloadOutlined } from '@ant-design/icons-vue'
import { parseAddress } from '@/utils/util'
import ls from '@/utils/Storage'
const UserInfo = ls.get('USER_INFO')
const emit = defineEmits(['ok', 'cancel'])
const format = 'YYYY-MM-DD HH:mm:ss'
import { useStore } from 'vuex'
const $store = useStore()
const formRef = ref()
// 防抖器
let timer: any = null
const formLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 }
    }
}
// 定时器
let interval
onBeforeUnmount(() => {
    clearInterval(interval)
})
//规则
const rules: Record<string, Rule[]> = {
    send_paua: [{ required: true, message: '请选择寄件人地址' }],
    receive_paua: [{ required: true, message: '请选择收件人地址' }],
    pay_type: [{ required: true, message: '请选择付款方式' }],
    is_timing: [{ required: true, message: '请选择邮寄时间' }]
}

interface state {
    loading: boolean
    maskClosable: boolean //点击蒙层是否允许关闭
    modalTitle: string
    isEdit: boolean
    confirmLoading: boolean
    sendLoading: boolean
    receiveLoading: boolean
    parseReceiveAddressLoading: boolean
    parseReceiveAddressLoading2: boolean
}
const state = reactive<state>({
    loading: false,
    maskClosable: true,
    modalTitle: '新增邮寄',
    // 是否为编辑
    isEdit: false,
    confirmLoading: false,
    sendLoading: false,
    receiveLoading: false,
    parseReceiveAddressLoading: false,
    parseReceiveAddressLoading2: false
})

interface formState {
    mailing_kdgs: number
    pay_type: number
    is_timing: number
    goodsname: string
    remark: string
    timing_time: any
    receive_address: string
    receive_paua: string
    receive_tel: string
    receive_consignee_name: string
    send_address: string
    send_paua: string
    send_tel: string
    send_consignee_name: string
}
let formState = reactive<formState>({
    mailing_kdgs: 2,
    pay_type: 1,
    is_timing: 1,
    goodsname: '',
    remark: '',
    timing_time: null,
    receive_address: '',
    receive_paua: '',
    receive_tel: '',
    receive_consignee_name: '',
    send_address: '',
    send_paua: '',
    send_tel: '',
    send_consignee_name: ''
})
const props = defineProps({
    open: {
        type: Boolean
    },
    copyId: {
        type: Number,
        default: 0
    }
})

onMounted(() => {
    //添加顺丰邮寄
    formState.pay_type = 1
    if (props.copyId) {
        queryDetail()
    }
})

const queryDetail = () => {
    let requestParam = {
        url: `/admin/v1/otherLogistic/${props.copyId}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            Object.assign(formState, res.data)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
            state.loading = false
        })
}
const senderPauaChange = (e, val) => {
    let address = `${val[0].name}${val[1].name}${val[2].name}`
    formState.send_address = address
}
const recipientChange = (e, val) => {
    let address = `${val[0].name}${val[1].name}${val[2].name}`
    formState.receive_address = address
}
// 获取邮寄信息
const getMailling = (side) => {
    var tel = ''
    if (side == 1) {
        tel = formState.send_tel
    } else if (side == 2) {
        tel = formState.receive_tel
    }
    if (!tel) {
        message.warn('请填写手机号码再获取邮寄信息')
        return
    }
    if (side == 1) {
        state.sendLoading = true
    } else if (side == 2) {
        state.receiveLoading = true
    }
    //这个接口是用的客户管理的顺丰邮寄相同的接口
    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: tel
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                if (side == 1) {
                    state.sendLoading = false
                    formState.send_consignee_name = res.data.list[0].name
                    formState.send_tel = res.data.list[0].tel
                    formState.send_address = res.data.list[0].address
                    formState.send_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                } else if (side == 2) {
                    formState.receive_consignee_name = res.data.list[0].name
                    formState.receive_tel = res.data.list[0].tel
                    formState.receive_address = res.data.list[0].address
                    formState.receive_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                    state.receiveLoading = false
                }
            }
            message.success(res.msg)
        })
        .catch((res) => {
            if (res) {
                if (side == 1) {
                    state.sendLoading = false
                } else if (side == 2) {
                    state.receiveLoading = false
                }
                if (res.msg) {
                    message.warning(res.msg)
                    return
                }
            }
        })
    //   }
}
// 关闭
const cancelClick = (val) => {
    if (state.isEdit) {
        emit('cancel')
        return
    }
    emit('cancel')
}
// 提交
const onFormSubmit = () => {
    formRef.value
        .validate()
        .then(() => {
            state.loading = true
            let requeryParam = {
                url: '/admin/v1/otherLogistic',
                method: 'post',
                data: formState
            }
            baseService(requeryParam)
                .then((res: any) => {
                    message.success(res.msg)
                    state.loading = false
                    state.confirmLoading = false
                    emit('ok')
                })
                .catch((res) => {
                    state.loading = false
                    if (res) {
                        state.confirmLoading = false
                        if (res.msg) {
                            message.warning(res.msg)
                            return
                        }
                        message.warning('参数错误,请检查')
                    }
                })
        })
        .catch((val) => {
            state.loading = false
            message.warning('请检查必填项')
        })
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
}
//寄件人详细地址改变
const senderAddressChange = () => {
    if (formState.send_paua) {
        let arr = formState.send_paua.split(',')
        let requestParam = {
            url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
            method: 'get'
        }
        baseService(requestParam).then((res: any) => {
            if (res.data.length == 3) {
                let head3 = res.data[0].name + res.data[1].name + res.data[2].name
                let head2 = res.data[1].name + res.data[2].name
                let head1 = res.data[2].name
                formState.send_address = formState.send_address.trim()
                if (formState.send_address.indexOf(head3) == 0) {
                    formState.send_address = formState.send_address.replace(head3, '')
                } else if (formState.send_address.indexOf(head2) == 0) {
                    formState.send_address = formState.send_address.replace(head2, '')
                } else if (formState.send_address.indexOf(head1) == 0) {
                    formState.send_address = formState.send_address.replace(head1, '')
                }
                formState.send_address = head3 + formState.send_address
            }
        })
    }
}
const receiveAddressChange = () => {
    if (formState.receive_paua) {
        let arr = formState.receive_paua.split(',')
        let requestParam = {
            url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
            method: 'get'
        }
        baseService(requestParam).then((res: any) => {
            if (res.data.length == 3) {
                let head3 = res.data[0].name + res.data[1].name + res.data[2].name
                let head2 = res.data[1].name + res.data[2].name
                let head1 = res.data[2].name
                formState.receive_address = formState.receive_address.trim()
                if (formState.receive_address.indexOf(head3) == 0) {
                    formState.receive_address = formState.receive_address.replace(head3, '')
                } else if (formState.receive_address.indexOf(head2) == 0) {
                    formState.receive_address = formState.receive_address.replace(head2, '')
                } else if (formState.receive_address.indexOf(head1) == 0) {
                    formState.receive_address = formState.receive_address.replace(head1, '')
                }
                formState.receive_address = head3 + formState.receive_address
            }
        })
    }
}
//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.send_address).then((res: any) => {
        if (res.name) {
            formState.send_consignee_name = res.name
        }
        if (res.phone) {
            formState.send_tel = res.phone
        }
        if (res.area_ids) {
            formState.send_paua = res.area_ids
        }
        if (res.address) {
            formState.send_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
const parseReceiveAddress2 = () => {
    state.parseReceiveAddressLoading2 = true
    parseAddress(formState.receive_address).then((res: any) => {
        if (res.name) {
            formState.receive_consignee_name = res.name
        }
        if (res.phone) {
            formState.receive_tel = res.phone
        }
        if (res.area_ids) {
            formState.receive_paua = res.area_ids
        }
        if (res.address) {
            formState.receive_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading2 = false
    })
}
</script>

<style lang="less" scoped></style>
